import { LoginGoogleResponce } from './../../../core/model/authentication-response-model';
import { MetrixService } from './../analytics-repository/metrix.service';
import { Injectable } from '@angular/core';
import { baseUrl, appVersion } from 'src/app/global-variables';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GenericResponse, GenericResponseData } from '../generic-response';
import {
  SendSmsResponse,
  UserResponse,
  GetUserResponse,
  GetPromotionUser,
  LoginGoogleParams,
} from 'src/app/core/model/authentication-response-model';
import { DeviceInfoHelper } from 'src/app/utils/device-info-helper';
import { UserDataService } from './user-data.service';
import { RegisterResponse } from 'src/app/core/model/register-response-model';
import { RegisterShared } from 'src/app/presentation/general/shared/register-shared';
import { UserRefreshTokenService } from './user-refresh-token.service';
import { SettingsAnalyticsService } from '../analytics-repository/settings-analytics.service';
import { WebengageService } from '../analytics-repository/webengage.service';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  constructor(
    private userRefreshTokenService: UserRefreshTokenService,
    private http: HttpClient,
    private deviceInfoHelper: DeviceInfoHelper,
    private userDataService: UserDataService,
    private registerShared: RegisterShared,
    private settingAnalytics: SettingsAnalyticsService,
    private webengage: WebengageService
  ) {}

  sendSMS(username: string): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = {
      'x-deviceType': 'pwa',
      'x-versionCode': '81',
    };
    return this.http
      .post<SendSmsResponse>(
        baseUrl + 'api/v2/users/',
        {
          username,
          market: 'pwa',
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        const data = new GenericResponseData({ message: res.message });
        response = new GenericResponse(res.success, data);
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 400) {
          response = new GenericResponse(
            false,
            new GenericResponseData({ message: e.error.message })
          );
          return response;
        }
        response = new GenericResponse(false);
        return response;
      });
  }

  login(username: string, code: string) {
    const os = this.deviceInfoHelper.getDeviceOS();
    const base64 = 'Basic ' + btoa(username + ':' + code);
    const headerDict = {
      Authorization: base64,
      'x-deviceType': 'pwa',
      'x-versionCode': '81',
    };
    let response: GenericResponse;
    return this.http
      .post<UserResponse>(
        baseUrl + 'api/v2/users/login',
        {
          deviceId: '',
          deviceType: 'PWA',
          deviceVersion: os,
          market: 'pwa',
          appVersion,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        // console.log(res);
        if (res.success) {
          console.log(res.user.name);

          let data: GenericResponseData;
          if (
            res.user.name === null ||
            res.user.name === undefined ||
            res.user.name === ''
          ) {
            data = new GenericResponseData({
              message: res.message,
              type: 'register',
            });
            // register
          } else {
            this.webengage.userLoggedin(res.user);
            data = new GenericResponseData({
              message: res.message,
              type: 'login',
            });

            // login
          }

          this.userDataService.saveUser(res.user);
          this.userDataService.saveToken(res.token);
          this.userDataService.saveRefreshToken(res.refreshToken);
          this.s2sloginMetrix();
          response = new GenericResponse(true, data);
        } else {
          response = new GenericResponse(
            false,
            new GenericResponseData({ message: res.message })
          );
        }
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 400) {
          response = new GenericResponse(
            false,
            new GenericResponseData({ message: e.error.message })
          );
          return response;
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  async getUser(): Promise<GenericResponse> {
    let response: GenericResponse;
    const userUpdatedAt = localStorage.getItem('userUpdatedAt');
    if (
      userUpdatedAt &&
      new Date().getTime() - new Date(userUpdatedAt).getTime() < 30 * 60 * 1000
    ) {
      const user = await this.userDataService.getUser();
      if (user) {
        response = new GenericResponse(true);
        return response;
      }
    }
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<GetUserResponse>(baseUrl + 'api/v2/users/user', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((result) => {
        // console.log('getuser', result);
        if (result) {
          this.userDataService.saveUser(result.data);
          response = new GenericResponse(true);
        } else {
          response = new GenericResponse(false);
        }
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getUser();
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  registerUser(): Promise<GenericResponse> {
    return this.userDataService.getUser().then((usr) => {
      let user = usr;
      let response: GenericResponse;
      const date = this.registerShared.birthdate.getTime();
      user.name = this.registerShared.name;
      user.sex = this.registerShared.gender;
      user.birthDate = date;
      user.weight = this.registerShared.weight;
      user.height = this.registerShared.height;
      const referrer = this.registerShared.referrer;
      const headerDict = this.userDataService.getHeaderDict();
      const metrixUserId = localStorage.getItem('METRIX_CHART_CLIENT_ID')
        ? localStorage.getItem('METRIX_CHART_CLIENT_ID')
        : null;
      const metrixSessionId = localStorage.getItem('METRIX_SESSION_ID')
        ? localStorage.getItem('METRIX_SESSION_ID')
        : null;

      return this.http
        .patch<RegisterResponse>(
          baseUrl + 'api/v2/users/',
          {
            market: 'pwa',
            weight: this.registerShared.weight,
            height: this.registerShared.height,
            birthDate: date,
            name: this.registerShared.name,
            sex: this.registerShared.gender,
            referrer,
            metrixUserId:
              metrixUserId && metrixUserId !== '' ? metrixUserId : null,
            metrixSessionId:
              metrixSessionId && metrixSessionId !== ''
                ? metrixSessionId
                : null,
          },
          {
            headers: new HttpHeaders(headerDict),
          }
        )
        .toPromise()
        .then((res) => {
          if (res.success) {
            this.webengage.registered();
            this.userDataService.saveUser(user);
            if (res.reward && res.reward > 0) {
              localStorage.setItem('referral-success', '1');
            }
          }
          const data = new GenericResponseData({ message: res.message });
          response = new GenericResponse(res.success, data);
          return response;
        })
        .catch((e) => {
          console.log(e.status, e);
          if (e.status === 403 || e.status === 401) {
            this.userRefreshTokenService.refreshToken().then((resp) => {
              if (resp.isSuccess()) {
                this.registerUser();
              }
            });
          }
          response = new GenericResponse(
            false,
            new GenericResponseData({ message: 'خطای اتصال' })
          );
          return response;
        });
    });
  }

  editUser(
    name?: string,
    sex?: string,
    birthDate?: number,
    weight?: number,
    height?: number,
    metrixUserId?: string,
    metrixSessionId?: string
  ): Promise<GenericResponse> {
    return this.userDataService.getUser().then((usr) => {
      let user = usr;
      let response: GenericResponse;
      // console.log(name, sex, birthDate, weight, height)
      if (name) {
        user.name = name;
      }
      if (sex) {
        user.sex = sex;
      }
      if (birthDate) {
        user.birthDate = birthDate;
      }
      if (weight) {
        user.weight = weight;
      }
      if (height) {
        user.height = height;
      }
      // console.log(user.name, user.sex, user.birthDate, user.weight, user.height)
      const headerDict = this.userDataService.getHeaderDict();
      return this.http
        .patch<RegisterResponse>(
          baseUrl + 'api/v2/users/',
          {
            market: 'pwa',
            weight: user.weight,
            height: user.height,
            birthDate: user.birthDate,
            name: user.name,
            sex: user.sex,
            metrixUserId: metrixUserId ? metrixUserId : null,
            metrixSessionId: metrixSessionId ? metrixSessionId : null,
          },
          {
            headers: new HttpHeaders(headerDict),
          }
        )
        .toPromise()
        .then((res) => {
          if (res.success) {
            if (name) {
              this.settingAnalytics.analyticSettingNameChanged();
            }
            if (sex) {
              this.settingAnalytics.analyticSettingGenderChanged();
            }
            if (birthDate) {
              this.settingAnalytics.analyticSettingBirthdayChanged();
            }
            if (weight) {
              this.settingAnalytics.analyticSettingWeightChanged();
            }
            if (height) {
              this.settingAnalytics.analyticSettingHeightChanged();
            }
            (window as any).webengage.user.login(user._id);
            if (user.email) {
              (window as any).webengage.user.setAttribute('email', user.email);
            }
            if (user.username) {
              (window as any).webengage.user.setAttribute(
                'number',
                '+98' + user.username.substring(1)
              );
            }
            if (user.name) {
              (window as any).webengage.user.setAttribute('name', user.name);
            }
            this.userDataService.saveUser(user);
          }
          const data = new GenericResponseData({ message: res.message });
          response = new GenericResponse(res.success, data);
          return response;
        })
        .catch((e) => {
          console.log(e.status, e);
          if (e.status === 403 || e.status === 401) {
            this.userRefreshTokenService.refreshToken().then((resp) => {
              if (resp.isSuccess()) {
                this.editUser(name, sex, birthDate, weight, height);
              }
            });
          }
          response = new GenericResponse(
            false,
            new GenericResponseData({ message: 'خطای اتصال' })
          );
          return response;
        });
    });
  }

  async getPromotionUser(): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<GetPromotionUser>(baseUrl + 'api/v2/promotion/user', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((result) => {
        // console.log('getuser', result);
        if (result.success && result.hasPromotion) {
          response = new GenericResponse(true);
        } else {
          response = new GenericResponse(false);
        }
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getPromotionUser();
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  googleAuth(tokenId: string): Promise<GenericResponse> {
    const os = this.deviceInfoHelper.getDeviceOS();
    let response: GenericResponse;

    return this.http
      .post<LoginGoogleResponce>(baseUrl + 'api/v2/users/google', {
        idToken: tokenId,
        deviceId: '',
        deviceType: 'PWA',
        deviceVersion: os,
        acquisitionSource: null,
        market: 'pwa',
        appVersion,
      })
      .toPromise()
      .then((res) => {
        console.log(res);
        if (res.success) {
          let data: GenericResponseData;
          if (res.newUser === true) {
            data = new GenericResponseData({
              message: res.message,
              type: 'register',
            });
            // register
          } else {
            data = new GenericResponseData({
              message: res.message,
              type: 'login',
            });
            // login
          }
          this.webengage.authenticated('google');
          this.userDataService.saveUser(res.user);
          this.userDataService.saveToken(res.token);
          this.userDataService.saveRefreshToken(res.refreshToken);
          this.s2sloginMetrix();

          response = new GenericResponse(true, data);
        } else {
          response = new GenericResponse(
            false,
            new GenericResponseData({ message: res.message })
          );
        }
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 400) {
          response = new GenericResponse(
            false,
            new GenericResponseData({ message: e.error.message })
          );
          return response;
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }
  s2sloginMetrix() {
    const metrixUserId = localStorage.getItem('METRIX_CHART_CLIENT_ID')
      ? localStorage.getItem('METRIX_CHART_CLIENT_ID')
      : null;
    const metrixSessionId = localStorage.getItem('METRIX_SESSION_ID')
      ? localStorage.getItem('METRIX_SESSION_ID')
      : null;
    const headerDict = this.userDataService.getHeaderDict();

    console.log('metrix user id :', metrixUserId);
    console.log(typeof metrixUserId);

    if (metrixUserId != '') {
      this.http
        .post<{
          success: boolean;
          message_id: number;
          message: string;
          statusCode: number;
          data: any;
          clientValidation: string;
        }>(
          baseUrl + 'api/v2/metrix/s2s',
          {
            market: 'pwa',
            metrixUserId: metrixUserId,
            metrixSessionId: metrixSessionId,
          },
          {
            headers: new HttpHeaders(headerDict),
          }
        )
        .toPromise()
        .then((res) => {
          if (res.success) {
            console.log('metrix login success');
          }
        });
    } else {
      console.log('no metrix user id ');
    }
    console.log('end metrix');
  }
}
